<script setup>
import { useGeneralStore } from '@/stores/general';

const generalStore = useGeneralStore();

const props = defineProps({
	download_url: {
		type: String,
		required: false,
		default: ''
	}
});

const redirectStore = () => {
	if (props.download_url) {
		window.location.href = props.download_url;
	} else {
		window.location.reload();
	}
}
</script>
<template>
	<div class="modal-outer verify-email-popup" ref="modal">
		<div class="overlay"></div>
		<div class="modal">
			<div class="password-reset-main" style="text-align: center; padding: 20px;">
				<div class="popup-message">
					<h5 style="color: var(--primary); font-size: 20px; margin-bottom: 15px;">Update Required</h5>
					<p style="font-size: 14px; line-height: 1.5; margin-bottom: 25px;">A new version of {{ generalStore.getGeneral?.site_name || 'the app' }} is available. Please update to the latest version to continue.</p>
				</div>
				<div class="button-container">
					<button class="btn btn-secondary w-100" type="button" @click="redirectStore">Download Update</button>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
.modal {
	width: 100% !important;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.modal-outer .modal {
	z-index: 100001; /* ensuring it overlays top */
}
.popup-message h5{
	color: var(--primary);
	padding-bottom: 6px;
	font-size: 20px;
}
.button-container {
	text-align: center;
}
</style>
